export default {
  getPerPage: (tab) => {
    return 15;
  },
  getHead: () => {
    return [
      { name: "No.", style: { minWidth: "100px", width: "100px" } },
      { name: "회사명", key: "field_name" },
      { name: "업종", key: "meta.업종" },
      { name: "규모", key: "meta.규모" },
      { name: "담당자", key: "director_name" },
      { name: "주소", key: "address" },
      { name: "사업장 연락처", key: "phone" },
    ];
  },
  getCol: (index, row, func) => {
    try {
      const meta = JSON.parse(row.meta);
      switch (index) {
        case 0:
          return func.no; // No.
        case 1:
          return row.field_name || "-"; // 회사명
        case 2:
          return meta.업종 || "-"; // 업종
        case 3:
          return meta.규모 || "-"; // 규모
        case 4:
          return row.director_name || "-"; // 담당자
        case 5:
          return row.address || "-"; // 주소
        case 6:
          return row.phone || "-"; // 사업장 연락처
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
};
